import React from 'react';
import './ServicesSection.css';
import TandemImg from '../assets/tandem_photo.png';
import AffImg from '../assets/aff_photo.png';
import EstaticaImg from '../assets/static_photo.png';

function ServicesSection() {
    const services = [
        {
            id: 1,
            title: 'Salto Tándem',
            description: 'Experimenta la adrenalina saltando junto a un instructor. Disponible en Los Cerrillos y Punta del Este.',
            price: '7800 pesos por persona',
            image: TandemImg,
            alt: 'Persona realizando un salto tándem en paracaídas con instructor'
        },
        {
            id: 2,
            title: 'Curso AFF',
            description: 'Aprende a volar solo con el método más eficiente. Comienza con 5 saltos de Línea Estática y 7 niveles AFF.',
            price: 'Requiere no pesar más de 80kg.',
            image: AffImg,
            alt: 'Estudiante de paracaidismo en curso AFF durante caída libre'
        },
        {
            id: 3,
            title: 'Curso de Línea Estática',
            description: 'Programa progresivo para aprender a controlar la caída libre. Incluye 30 saltos y examen DINACIA.',
            price: 'Incluye equipo completo y supervisión.',
            image: EstaticaImg,
            alt: 'Paracaidista realizando salto de línea estática desde avión'
        },
    ];

    return (
        <section id="services" className="services">
            <h2 className="services__title">Nuestros Servicios</h2>
            <div className="services__cards">
                {services.map((service) => (
                    <div key={service.id} className="services__card">
                        <img
                            src={service.image}
                            alt={service.alt}
                            className="services__card-image"
                            loading="lazy"
                        />
                        <h3 className="services__card-title">{service.title}</h3>
                        <p className="services__card-text">{service.description}</p>
                        <p className="services__card-price"><strong>{service.price}</strong></p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default ServicesSection;
